module.exports = function(service) {
	'use strict'
	service.factory('authInterceptor',authInterceptor);
	authInterceptor.$inject=['authtokenService','config','$rootScope'];
	function authInterceptor(authtokenService,config,$rootScope) {
		var appConfig = config;
		return {
			request: function(config) {
				var token;
				if (config.url && (config.url.includes('auth/renewRefreshToken') || config.url.includes('auth/logout')) || config.url.includes('auth/renewToken')) {
					token = authtokenService.getRefreshToken();
				} else {
					token = authtokenService.getToken();
				}
				if(token) {
					config.headers['x-auth'] = token;
				}
				if(appConfig && appConfig.version) {
					config.headers['x-version'] = appConfig.version
				}
				if($rootScope.tabSessionId) {
					config.headers['x-session-id'] = $rootScope.tabSessionId;
				}
				return config; 
			},
			response: function(response) {
				return response;
			}
		}
	}
}



//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/authInterceptor.js
// module id = 585
// module chunks = 0